// Function to send error message to Discord
const sendErrorDiscord = async (errorData, prefix, userContext = null) => {
  // Define the endpoint URL
  const url = prefix + "send/react-error";

  // Format error message in a human-readable way (if not already formatted)
  let formattedMessage = "";

  // Check if message is already formatted (contains emojis or markdown)
  if (typeof errorData === "string" && (errorData.includes("**") || errorData.includes("⚠️"))) {
    // Already formatted, use as-is
    formattedMessage = errorData;
  } else {
    // Format the message
    formattedMessage = "⚠️ **REACT ERROR**\n\n";

    // User information section
    if (userContext) {
      formattedMessage += "👤 **User Information:**\n";
      formattedMessage += `• Email: ${userContext.email || "N/A"}\n`;
      formattedMessage += `• User ID: ${userContext.uid || "N/A"}\n`;
      formattedMessage += `• Organization ID: ${userContext.org_id || "N/A"}\n\n`;
    }

    // Error details section
    formattedMessage += "⚠️ **Error Details:**\n";

    if (typeof errorData === 'object') {
      formattedMessage += `• Message: ${errorData.message || errorData.reason || "N/A"}\n`;
      formattedMessage += `• Timestamp: ${errorData.timestamp || "N/A"}\n`;
      formattedMessage += `• URL: ${errorData.url || "N/A"}\n`;

      if (errorData.source) {
        formattedMessage += `• Source: ${errorData.source}:${errorData.line}:${errorData.column}\n`;
      }

      formattedMessage += `• User Agent: ${errorData.userAgent || "N/A"}\n\n`;

      if (errorData.stack) {
        formattedMessage += "📋 **Stack Trace:**\n```\n";
        formattedMessage += errorData.stack.substring(0, 1500); // Limit stack trace length
        formattedMessage += "\n```";
      }
    } else {
      formattedMessage += errorData;
    }
  }

  let enrichedMessage = formattedMessage;

  // Define the request body
  const body = {
    message: enrichedMessage,
  };

  const headers = {
    "Content-Type": "application/json",
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    // Check if the request was successful
    if (response.ok) {
      console.log("Error sent to Discord successfully");
    } else {
      console.error(`Failed to send error: ${response.status}`);
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
  }
};

// Function to send crash error message to Discord (for crashing errors only)
const sendCrashErrorDiscord = async (errorData, prefix, userContext = null) => {
  // Define the endpoint URL for crash errors
  console.log("user context", userContext)
  const url = prefix + "send/crash-react-error";

  // Format error message in a human-readable way
  let formattedMessage = "🔴 **REACT CRASH ERROR**\n\n";

  // User information section
  if (userContext) {
    formattedMessage += "👤 **User Information:**\n";
    formattedMessage += `• Email: ${userContext.email || "N/A"}\n`;
    formattedMessage += `• User ID: ${userContext.uid || "N/A"}\n`;
    formattedMessage += `• Organization ID: ${userContext.org_id || "N/A"}\n\n`;
  }

  // Error details section
  formattedMessage += "⚠️ **Error Details:**\n";

  if (typeof errorData === 'object') {
    formattedMessage += `• Message: ${errorData.message || "N/A"}\n`;
    formattedMessage += `• Timestamp: ${errorData.timestamp || "N/A"}\n`;
    formattedMessage += `• URL: ${errorData.url || "N/A"}\n`;
    formattedMessage += `• User Agent: ${errorData.userAgent || "N/A"}\n\n`;

    if (errorData.stack) {
      formattedMessage += "📋 **Stack Trace:**\n```\n";
      formattedMessage += errorData.stack.substring(0, 1500); // Limit stack trace length
      formattedMessage += "\n```\n\n";
    }

    if (errorData.componentStack) {
      formattedMessage += "🧩 **Component Stack:**\n```\n";
      formattedMessage += errorData.componentStack.substring(0, 1000); // Limit component stack length
      formattedMessage += "\n```";
    }
  } else {
    formattedMessage += errorData;
  }

  let enrichedMessage = formattedMessage;

  // Define the request body
  const body = {
    message: enrichedMessage,
  };

  const headers = {
    "Content-Type": "application/json",
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    // Check if the request was successful
    if (response.ok) {
      console.log("Crash error sent to Discord successfully");
    } else {
      console.error(`Failed to send crash error: ${response.status}`);
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
  }
};

export default sendErrorDiscord;
export { sendCrashErrorDiscord };
